import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=20cc918f&scoped=true&lang=pug&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"
import style0 from "./summary.vue?vue&type=style&index=0&id=20cc918f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc918f",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/insurance?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230927162708%2Fcomponents%2Fproducts%2Finsurance%2Flife-insurance%2Fsummary.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./summary.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/image.vue').default})
